import { ChevronRight, Remove } from '@mui/icons-material';
import { Grid, Typography } from '@mui/material';
import classNames from 'classnames';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { MapIcon } from '~/Components/Icons';
import { WeekDay } from '~/Models/DTO/Provider.model';
import { Button } from '~/UIKit';
import { OpeningHoursSectionStyles } from '..';

export interface IOpeningHoursSectionTableRowProps {
  dataTable: WeekDay[];
  currentDay: string;
  onOpenDayModal: (currentDay: string) => void;
}

export const OpeningHoursSectionTableRow = ({
  dataTable,
  currentDay,
  onOpenDayModal,
}: IOpeningHoursSectionTableRowProps) => {
  const { classes } = OpeningHoursSectionStyles();
  const { t } = useTranslation();
  const handleOpenDay = () => {
    onOpenDayModal(currentDay);
  };
  return (
    <React.Fragment>
      {dataTable.map((_dayRow, dayRowIndex) => (
        <Grid data-testid="opening-hours-table-row" container key={dayRowIndex}>
          <Grid
            className={classNames({
              [classes.inactive]: dataTable.length === 0,
              [classes.hasBottomBorder]: dayRowIndex === dataTable.length - 1,
            })}
            container
            xs={6}
            alignSelf="normal"
            alignItems="self-start"
          >
            {dayRowIndex === 0 && (
              <Grid
                className={classNames(classes.dayRow)}
                key={dayRowIndex}
                alignItems="center"
                container
              >
                <Grid className={classes.iconWrapper}>
                  <MapIcon />
                </Grid>
                <Grid
                  container
                  flex={1}
                  alignItems="center"
                  className={classNames(classes.itemRow, classes.dayLabel, {
                    [classes.hasBottomBorder]: dayRowIndex === 0 && dataTable.length > 1,
                  })}
                >
                  {t(`app.weekdays.${currentDay}`)}
                </Grid>
              </Grid>
            )}
          </Grid>
          <Grid
            xs={6}
            container
            justifyContent="flex-end"
            data-testid="opening-hours-section-time-block"
            className={classes.hasBottomBorder}
          >
            <Grid key={dayRowIndex} container justifyContent="flex-end" alignItems="center">
              <Button variant="text" className={classes.timeButton} onClick={handleOpenDay}>
                <Typography>{_dayRow?.from?.toString().substring(0, 5)}</Typography>
                <Remove className={classNames(classes.separator, classes.hasMarginHorizontal)} />
                <Typography>{_dayRow?.to?.toString().substring(0, 5)}</Typography>
                <span className={classes.ChevronRight}>
                  <ChevronRight />
                </span>
              </Button>
            </Grid>
          </Grid>
        </Grid>
      ))}
    </React.Fragment>
  );
};
